import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../../endpoints/endpoint';
import { NetworkService } from '../../../services/network.service';
import { Utility } from '../../../utility/utility';
import { environment } from '../../../../environments/environment';
import { getCountryLabel } from '../../../utility/country.util';

@Component({
  selector: 'app-handset-view',
  templateUrl: './handset-view.component.html',
  styleUrls: ['./handset-view.component.css']
})
export class HandsetViewComponent implements OnInit, OnDestroy {

  settingsFilter ={
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      globalCustomerName: {
        title: 'Global Customer Name',
        filter:false
      },
      country: {
        title: 'Country',
        valuePrepareFunction: (country: string) => {
          return getCountryLabel(country);
        },
        filter:false
      },
      localCustomer: {
        title: 'Local Customer',
        filter:false
      },
      localCustomerName: {
        title: 'Local Customer Name',
        filter:false
      },
      catalogName: {
        title: 'Catalog Name',
        filter:false
      },
      lead: {
        title: 'LO',
        filter:false
      },
      owner: {
        title: 'BO',
        filter:false
      }


    },
    pager: {
      display: false
    }
  };

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: false
    },
    columns: {
      category:{
        title:'Category'
      },
      type: {
        title: 'Type'
      },
      productId: {
        title: 'Product Id'
      },
      productName: {
        title: 'Product Name'
      },
      storage: {
        title: 'Storage'
      },
      colour: {
        title: 'Colour'
      }


    }
  };

  listHandset: any[]=[];
  listCatalog: any[]=[];
  idCatalog: string;
  idCategory: string;
  destroy$ = new Subject<boolean>();

  constructor(private route: ActivatedRoute, private networkService: NetworkService, private toastr: ToastrManager, 
    private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit(): void {
    this.idCatalog = this.route.snapshot.params['idCatalog'];
    this.initiliazeHandsets();
  }

  initiliazeHandsets() {
    this.spinner.show("sp1");
    let getHandsets: string = environment.basePath + _ENDPOINT.getHandsets;
    let request = {
      idCatalog: this.idCatalog
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(getHandsets, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            let dataJson = JSON.parse(response.body);
            this.listCatalog = dataJson.listCatalog;
            this.listHandset = dataJson.listHandset;
            this.spinner.hide("sp1");
          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during handsets retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }
        }
        else{
          if(response && response.listCatalog && response.listHandset){
            this.listCatalog = response.listCatalog;
            this.listHandset = response.listHandset;
            this.spinner.hide("sp1");
          }else if(response && response.length && response.length>0 ){
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }else{
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during handsets retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }
        }

        
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during handsets retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
          this.router.navigate(['catalog-view']);
        });;
  }

  goToCatalogView(){
    this.router.navigate(['catalog-view']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
